import { useTranslation } from '@thoughtspot/i18n';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { Horizontal, Vertical } from "../../../utils/layouts";
import styles from './alert.module.scss';
export const AlertTable = ({ tableRowData, title, dataColumns, }) => {
    const { t } = useTranslation();
    const renderContent = () => (React.createElement(Vertical, { className: styles.table },
        React.createElement(Typography, { variant: "h3" }, title),
        React.createElement(Table, { className: styles.tableComponent, data: tableRowData, columns: dataColumns }),
        tableRowData && (React.createElement(Horizontal, { className: styles.tableFooter }, t('pagination_footer', {
            total: tableRowData.length,
        })))));
    return renderContent();
};
//# sourceMappingURL=alert.js.map